import { menuselect, getrouteparams } from "@/constant/menuselect";

let str = '国产化信创适配认证'
export const config = {
  title: str,
  headerInfo:
    "敬在医院智慧管理系统的国产化信创适配，通过全栈替代与业务深度融合，推动医疗系统向自主可控、安全高效转型。目前，已形成从底层芯片、操作系统（如银河麒麟）、数据库（如金仓数据库）到上层HIS、LIS、PACS等核心业务系统的全链路国产化方案，实现平滑迁移与生态协同。此举不仅消除了数据安全“卡脖子”风险，还通过优化数据底座提升了运营效率，为智慧医院建设奠定了自主可控的基石。",
  headerImg: require("@/assets/images/adaptationCert/header.jpg"),
  activeTitle: str,
  activeSubTitle: str,

  navList: [
    {
      name: str,
      children: menuselect(),
    },
    {
      name: "产品概述",
      desc: '2022年1月6日，国家发改委公布了《“十四五"推进国家政务信息化规划》明确2022- 2025年将开启新一轮数字经济建设周期。提出：“到2025年国家电子政务网安全保障达到新水平，全面落实信息安全和信息系统等级分级保护制度，基本实现政务信息化安全可靠应用，确保政务信息化建设和应用全流程安全可靠”。为加快推进国内信创产业，我国提出“2 + 8”体系，其中医疗行业位列国计民生八大行业之中，各医疗行业各单位也积极开展了医疗信创部署工作，积极推动信创行业在医疗领域的发展。',
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: "",
          img: require("@/assets/images/adaptationCert/content1.png"),
        },
        {
          title: "安全可靠的信息技术已获得权威认证",
          desc: " ",
          img: require("@/assets/images/adaptationCert/01.png"),
        },
        {
          title: "相关证书",
          desc: " ",
          img: require("@/assets/images/adaptationCert/02.png"),
        },
      ],
    },
  ],
};
